export default __webpack_public_path__ + "static/media/horse.915811e2.jpg";